<template>
    <button
        type="button"
        :aria-label="`${$t('INSPECT')} ${ariaLabelText}`"
        @click.prevent="openModal"
        ref="inspectButton"
        :class="[
            inspectOverlay ? 'is-full-size' : 'selection-card__inspect',
        ]"
        class="cz2__inspect-trigger"
    >
        <span
            v-if="inspectOverlay"
            class="selection-card__inspect"
        />
    </button>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__inspect-trigger {
            position: relative;

            &:focus-visible {
                outline: none;
                border-radius: 0;

                &:after {
                    content: '';

                    position: absolute;
                    left: -4px;
                    top: -4px;

                    width: calc(100% + 7px);
                    height: calc(100% + 7px);

                    border: 1px solid #fff;
                    border-radius: 8px;
                }
            }

            &.is-full-size {
                width: 100%;
                height: 100%;

                &:focus-visible {
                    &:after {
                        z-index: 1;
                        border-width: 4px;
                    }
                }
            }
        }
    }
</style>

<script>
    export default {
        props: {
            ariaLabelText: {
                type: String,
                default: '',
            },

            inspectOverlay: {
                type: Boolean,
                default: false,
            },

            isAttachPack: {
                type: Boolean,
                default: false,
            },

            component: Object,
        },

        data() {
            return {
                shouldReclaimFocus: false,
            };
        },

        computed: {
            inspectModalShown() {
                return this.$store.state.inspectModalShown;
            },

            attachPackModalShown() {
                return this.$store.state.attachPackModalShown;
            },
        },

        watch: {
            inspectModalShown() {
                if (this.inspectModalShown && this.component.code === this.$store.state.inspectModalComponent.code) {
                    this.$refs.inspectButton.focus();
                    this.shouldReclaimFocus = true;
                }
                if (!this.inspectModalShown && this.shouldReclaimFocus) {
                    this.$refs.inspectButton.focus();
                    this.shouldReclaimFocus = false;
                }
            },

            attachPackModalShown() {
                if (this.attachPackModalShown && this.component.code === this.$store.state.attachPackModalComponent.code) {
                    this.$refs.inspectButton.focus();
                    this.shouldReclaimFocus = true;
                }
                if (!this.attachPackModalShown && this.shouldReclaimFocus) {
                    this.$refs.inspectButton.focus();
                    this.shouldReclaimFocus = false;
                }
            },
        },

        methods: {
            openModal() {
                const modalToOpen = this.isAttachPack ? 'AttachPack' : 'Inspect';

                this.$store.dispatch(`set${modalToOpen}ModalComponent`, this.component);
                this.$store.dispatch(`show${modalToOpen}Modal`, true);
            },
        },
    };
</script>
